import * as Yup from 'yup'

export const FIRST_NAME = 'first_name'
export const LAST_NAME = 'last_name'
export const PHONE_NUMBER = 'phone_number'
export const COUNTRY = 'country'

export const getInitialValues = user => {
  const { first_name, last_name, phone_number, country } = user

  return {
    [FIRST_NAME]: first_name || '',
    [LAST_NAME]: last_name || '',
    // remove + sign from BE number
    [PHONE_NUMBER]: phone_number.split('+')[1] || '',
    [COUNTRY]: country || ''
  }
}

export const validationSchema = Yup.object({
  [FIRST_NAME]: Yup.string().required('Please enter your first name'),
  [LAST_NAME]: Yup.string().required('Please enter your last name'),
  [PHONE_NUMBER]: Yup.string().test({
    message: 'Please enter a valid phone number',
    // allow empty value or min 6 chars
    test: value => !value || (!!value && value.length > 6)
  })
})
